export const apiTypes = [
  { key: 'abc_photosigns', label: 'ABC Photosigns' },
  { key: 'briner', label: 'Briner' },
  { key: 'campaigntrack', label: 'Campaigntrack' },
  { key: 'campaign_agent', label: 'Campaign Agent' },
  { key: 'domain_xml', label: 'Domain' },
  { key: 'facebook', label: 'Facebook' },
  { key: 'integration', label: 'Integration' },
  { key: 'media_vendor', label: 'Media Vendor' },
  { key: 'newscorp_xml', label: 'Newscorp' },
  { key: 'printco', label: 'Printco' },
  { key: 'realbase', label: 'Realbase' },
  { key: 'reaxml', label: 'REAXML' },
  { key: 'slack', label: 'Slack' },
  { key: 'vaultre', label: 'VaultRE' },
  { key: 'vfx', label: 'VFX' },
  { key: 'webhook', label: 'Webhook' },
  { key: 'xero', label: 'Xero' },
  { key: 'zuora', label: 'Zuora' },
]

export const apiLogEvents = [
  { key: 'agency.created', label: 'agency.created' },
  { key: 'agency.export', label: 'agency.export' },
  { key: 'agency.updated', label: 'agency.updated' },
  { key: 'artwork.notified', label: 'artwork.notified' },
  { key: 'brand.created', label: 'brand.created' },
  { key: 'brand.export', label: 'brand.export' },
  { key: 'brand.updated', label: 'brand.updated' },
  { key: 'campaign.created', label: 'campaign.created' },
  { key: 'campaign.export', label: 'campaign.export' },
  { key: 'campaign.get_campaign_items', label: 'campaign.get_campaign_items' },
  { key: 'campaign.import', label: 'campaign.import' },
  { key: 'campaign.inspections', label: 'campaign.inspections' },
  { key: 'campaign.sold', label: 'campaign.sold' },
  { key: 'campaign.updated', label: 'campaign.updated' },
  { key: 'campaign.vendors', label: 'campaign.vendors' },
  { key: 'campaign_agent.base', label: 'campaign_agent.base' },
  { key: 'campaign_agent.webhook', label: 'campaign_agent.webhook' },
  { key: 'campaign_proposal.created', label: 'campaign_proposal.created' },
  { key: 'campaign_proposal.updated', label: 'campaign_proposal.updated' },
  { key: 'campaigns.search', label: 'campaigns.search' },
  { key: 'campaigntrack.base', label: 'campaigntrack.base' },
  { key: 'docusign.base', label: 'docusign.base' },
  { key: 'facebook.ad', label: 'facebook.ad' },
  { key: 'facebook.ad_campaign', label: 'facebook.ad_campaign' },
  { key: 'facebook.ad_creative', label: 'facebook.ad_creative' },
  { key: 'facebook.ad_set', label: 'facebook.ad_set' },
  { key: 'facebook.base', label: 'facebook.base' },
  { key: 'image.export', label: 'image.export' },
  { key: 'invoice.export', label: 'invoice.export' },
  { key: 'mydesktop.request', label: 'mydesktop.request' },
  { key: 'myob_advanced.request', label: 'myob_advanced.request' },
  { key: 'order.approved', label: 'order.approved' },
  { key: 'order.deleted', label: 'order.deleted' },
  { key: 'order.unapproved', label: 'order.unapproved' },
  { key: 'order_item.approved', label: 'order_item.approved' },
  { key: 'order_item.deleted', label: 'order_item.deleted' },
  { key: 'provider.export', label: 'provider.export' },
  { key: 'publication_booking.approved', label: 'publication_booking.approved' },
  { key: 'publication_booking_item.cancelled', label: 'publication_booking_item.cancelled' },
  { key: 'publication_order.approved', label: 'publication_order.approved' },
  { key: 'reiv_forms.base', label: 'reiv_forms.base' },
  { key: 'rex.request', label: 'rex.request' },
  { key: 'slack.submit_webhook', label: 'slack.submit_webhook' },
  { key: 'task.approved', label: 'task.approved' },
  { key: 'task.deleted', label: 'task.deleted' },
  { key: 'task.updated', label: 'task.updated' },
  { key: 'template_page.deleted', label: 'template_page.deleted' },
  { key: 'template_page.duplicated', label: 'template_page.duplicated' },
  { key: 'user.authenticate', label: 'user.authenticate' },
  { key: 'user.created', label: 'user.created' },
  { key: 'user.export', label: 'user.export' },
  { key: 'user.fetch', label: 'user.fetch' },
  { key: 'user.updated', label: 'user.updated' },
  { key: 'vaultre.request', label: 'vaultre.request' },
  { key: 'xero.create_credit_note', label: 'xero.create_credit_note' },
  { key: 'xero.create_invoice', label: 'xero.create_invoice' },
  { key: 'xero.wrapper', label: 'xero.wrapper' },
  { key: 'youtube.base', label: 'youtube.base' },
]

export default apiTypes
